/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Watchnow1Inputs */

const ja_nav_watchnow1 = /** @type {(inputs: Nav_Watchnow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運営イベント`)
};

const en_nav_watchnow1 = /** @type {(inputs: Nav_Watchnow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WATCH NOW`)
};

/**
* | output |
* | --- |
* | "WATCH NOW" |
*
* @param {Nav_Watchnow1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const nav_watchnow1 = /** @type {((inputs?: Nav_Watchnow1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Watchnow1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_nav_watchnow1(inputs)
	return en_nav_watchnow1(inputs)
});
export { nav_watchnow1 as "nav_watchNow" }